<template>
  <div class="log-box">
    <div style="margin:15px;">
      <el-button type="primary" @click="getData(page)">刷新</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" max-height="550" border>
        <el-table-column
          show-overflow-tooltip
          v-for="item in $public.info"
          :key="item.key"
          :prop="item.key"
          align="center"
          :label="item.value">
        </el-table-column>
        <el-table-column label="详情" type="expand">
          <template slot-scope="props"> 
            <div v-if="props.row.fileIds === ''?false:true">
              <span   v-for="(item,index) in props.row.fileIds"
                  :key="index"
                  style="margin-left:10px"
                  >
                <el-image 
                  style="width: 100px; height: 100px"
                  :src="item"
                  :preview-src-list="props.row.fileIds">
                </el-image>
              </span>
            </div>
            <div v-else>
              <span>无详情图片</span>
            </div>
            <div class="content">
              <h3>服务内容：</h3>
              <p>{{props.row.serviceContent}}</p>
            </div>
            <div class="content">
              <h3>服务结果：</h3>
              <p>{{props.row.serviceResult}}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <paging
        :pagesData="paging_data"
        @set_page_number = 'get_page_number'
    ></paging>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      paging_data:{
        currentPage:1,
        pageSize:50,
        total:0,
      },
      api:'/user/helpLog',
      tableData:[],
      page:1
    }
  },
  created() {
    this.getData(this.page)
  },
  methods:{
    //分页
    get_page_number(pageNumer) {
      this.getData(pageNumer)
    },
    getData(page) {
      let vm = this
      this.$api.getMyLog({pageNumber:page}).then(res =>{
        if (res.data.status === 0) {
          vm.paging_data.total = res.data.size
          vm.paging_data.pageSize = res.data.pageSize
          vm.tableData = JSON.parse(res.data.data)
          if(vm.tableData.length === 0) {
            return vm.$message.info('无相关信息')
          } else {
            
            this.$notify({
              title: '',
              message: '刷新成功！',
              type: 'success'
            })
            vm.tableData.forEach(element => {
              element.operateLogType = vm.$public.type[element.operateLogType - 1]
              if (element.fileIds === '') {} else {
                element.fileIds = element.fileIds.split(",")
                element.fileIds.forEach((item,index) => {
                  element.fileIds[index] = vm.$api.imgUrl+ '/user/img/' +item
                })
              }
            })
          }
        } else {
          this._status(res.data)
        }
      })

    },
  },
    
  beforeRouteEnter:(to,from,next)=>{
    next(vm=>{
      // console.log(vm.$route.params.info)
      if(vm.$route.params.info === undefined) {
        // console.log('123')
      } else {
        vm.jump ('Form_grxxcj',vm.$route.params.info)
      }
    })
  }
}
</script>
<style scoped>
.content{
  width: 100%;
  word-wrap: break-word; 
  word-break: normal;
}
</style>